export default "__VITE_ASSET__CTq95HdM__"